module.exports = __webpack_public_path__ + "img/yolo13.8e318b34.png";